import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';

import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

import { assest } from '../../assest/assest';

const CustomNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (path) => {
    if (path.startsWith("#")) {
      window.location.href = path;
    } else {
      navigate(path);
    }
    setIsMenuOpen(false);
  };

  const handleButtonClick = () => {
    // Trigger the link click directly inside the function
    window.location.hash = '#top'; // Navigates to the section with id "top"
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" className="custom-navbar fixed-top">
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              src={assest.expo}
              width="220"
              height="50"
              alt="Logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
          <Navbar.Collapse id="basic-navbar-nav" in={isMenuOpen}>
            <Nav className="mx-auto custom-nav">
              <Nav.Link onClick={() => handleLinkClick('/')}>Home</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('/articles')}>Tours</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#footer')}>Contact</Nav.Link>
              <Nav.Link onClick={() => handleLinkClick('#about')}>About</Nav.Link>
            </Nav>
            <Button 
              variant="outline-light" 
              className="btn-e-magazine ms-lg-3" 
              onClick={handleButtonClick}
            >
              <img src={assest.td} alt="" />Trending
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {isMenuOpen && <div className="overlay" onClick={handleToggle}></div>}
    </>
  );
};

export default CustomNavbar;
